import ToggleActive from "@app/utils/toggle-active";

export class FooterLinks {
    linkListElements: Array<ToggleActive> = [];

    constructor() {
        this.configureLinkList();
    }

    configureLinkList = () => {
        const targets = document.querySelectorAll(".links-container__link-block");
        targets.forEach(element => {
            this.applylinkListToggleTrigger(element as HTMLElement);
        });
    }

    applylinkListToggleTrigger = (element: HTMLElement) => {
        const trigger = element.firstElementChild;
        if (trigger !== null && trigger.classList.contains("footer-title")) {
            const titleElement = element.firstElementChild as HTMLElement;
            const child = element.querySelector(".link-list") as HTMLElement;
            const targetElements: Array<HTMLElement> = [element, titleElement, child];
            const newToggle = new ToggleActive(targetElements, trigger as HTMLElement);
            newToggle.setPreEvent(this.closeOpenLinkListMenus);
            this.linkListElements.push(newToggle);
        }
    }

    closeOpenLinkListMenus = (event: Event) => {
        this.linkListElements.forEach(toggleActive => {
            if (toggleActive.trigger !== event.target) {
                toggleActive.forceOff();
            }
        });
    }
}